import { useMemo } from 'react';

import { isMobile } from '@zola-helpers/client/dist/es/util/responsive';
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';

import cx from 'classnames';

import { useUserContext } from '~/contexts/UserContext';
import { CtaType, TrackingProductLocation } from '~/util/trackingHelper';

import styles from '../bookedTileV2.module.less';

export interface CrossSellProps {
  handleClick: () => void;
}

export const CROSS_SELL_WEBSITE = '/wedding/onboard/wedding-website';
export const CROSS_SELL_HAS_WEBSITE = '/wedding/manage/website/pages/event';

export const CrossSellWebsite = ({ handleClick }: CrossSellProps) => {
  const userContext = useUserContext();

  const href = useMemo(() => {
    return userContext?.has_website ? CROSS_SELL_HAS_WEBSITE : CROSS_SELL_WEBSITE;
  }, [userContext]);

  return (
    <ButtonV3
      component="a"
      aria-label="Zola Wedding Website"
      className={cx(styles.crossSellButton, { [styles.mobileCrossSellButton]: isMobile() })}
      href={href}
      onClick={handleClick}
      textTransform={false}
      fullWidth
    >
      Add to your wedding website
    </ButtonV3>
  );
};

export const TRACKING_PROPS = {
  business_unit: 'MARKETPLACE',
  location: TrackingProductLocation.SEARCH_RESULTS,
  cta_id: 'Cross Sell Website',
  cta: CROSS_SELL_WEBSITE,
  cta_type: CtaType.LINK,
  group_id: 'Cross Sell',
  position: 1,
  section: 'MARKETING',
};

export default CrossSellWebsite;
